<bwh-lib-step-control-bar
  [langDropdown]="true"
  [prevBut]="prevBut"
  [closeBut]="closeBut"
  [currentStep]="wizardService?.currentStep"
  [previousStep]="wizardService?.previousStep"
  [steps]="wizardService?.totalSteps"
  (emitPrev)="goPrev()"
></bwh-lib-step-control-bar>
<div class="file-upload-container scrollable-content">
  <div class="main-header">
    <div class="header-titles" *ngIf="loading" [@fadeInOut]>
      <h1 class="main-title">{{ 'global.we_are_checking_your_cv' | translate }}</h1>
      <h3 class="main-subtitle">{{ 'global.it_can_take_few_seconds' | translate }}</h3>
    </div>
    <div class="header-titles" *ngIf="!loading" [@fadeInOut]>
      <h1 class="main-title">{{ 'global.do_you_have_your_cv' | translate }}</h1>
      <h3 class="main-subtitle">{{ 'global.uploaded_subtitle' | translate }}</h3>
    </div>
  </div>
  <ng-lottie *ngIf="loading" [options]="options" [@fadeInOut]></ng-lottie>

  <div *ngIf="!loading" [@fadeInOut]>
    <bwh-lib-selected-item
      [name]="uploadedFile?.name || mockFileName"
      [iconStatus]="'checked'"
      (actionTriggered)="removeFile()"
      *ngIf="uploadedFile || mockFileName"
    ></bwh-lib-selected-item>

    <div class="error-container" *ngIf="uploadError">
      <img src="/assets/icons/error-icon.svg" alt="Error icon" />
      <p class="error-txt">
        <span>{{ 'global.upload_file_error_txt' | translate }}</span>
      </p>
      <p class="error-formats">
        <span *ngFor="let fileType of fileTypes">{{ fileType.label }}</span>
      </p>
    </div>

    <ul class="next-button-container" [class.error]="uploadError">
      <li *ngIf="prevBut === true">
        <button class="btn w-md h-lg primary prev-btn" type="button" (click)="goPrev()">
          {{ 'global.previous' | translate }}
        </button>
      </li>
      <li>
        <button class="btn w-md h-lg secondary" *ngIf="!uploadError" (click)="startCheckingCV()">
          {{ 'global.next_button' | translate }}
        </button>
        <button class="btn w-md h-lg secondary" *ngIf="uploadError" (click)="tryAgain()">
          {{ 'global.try_again' | translate }}
        </button>
      </li>
    </ul>
  </div>
</div>
